// 全局页面日志
export default defineNuxtRouteMiddleware((to, from) => {
  // console.log(to.path,'→',from.path)
})
